import { useQuery } from "@tanstack/react-query";
import { getUserProfileData } from "../../Requests";
import { useAppSelector } from "..";

function useUserProfileQuery(ssn: string) {
  const access_token = useAppSelector(state => state.auth.user?.access_token) ?? '';
  return useQuery({
    queryKey: ["userprofile", ssn],
    queryFn: () => getUserProfileData(access_token),
    enabled: !!access_token,
  });
}

export { useUserProfileQuery };
